import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface SmallChannelBadgeProps {
  /** Leading icon */
  readonly icon?: ReactNode;
  /** Label text */
  readonly label: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A tiny channel indicator with icon and text.
 * Smaller than ChannelChip — used inside list items.
 */
export function SmallChannelBadge({ icon, label, className }: SmallChannelBadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        "flex items-center gap-1 text-[10px] text-content-tertiary bg-surface-hover rounded-full px-1.5 py-0.5",
        className,
      )}
    >
      {icon}
      {label}
    </span>
  );
}
